// Module
var code = "<% _.each(dataSource, function(item) { %> <input type=\"checkbox\" name=\"{{item}}\" value=\"{{item}}\"/> {{item}} <% }); %>";
// Exports
export default code;